module.exports = __webpack_public_path__ + "static/media/monitor.3a739984.png";